import React from 'react';
import { FaExclamationTriangle, FaNetworkWired } from 'react-icons/fa';
import { vmIpInfo } from '../utils/format';

/**
 * Mostra l'IP principale mantenendo visibile la provenienza del dato:
 * "rilevato" da VMware Tools oppure "atteso" dal catalogo.
 */
export default function VmIpAddress({ vm, compact = false, showIcon = false }) {
  const info = vmIpInfo(vm);
  if (!info.primary) {
    return <span className="text-gray-400 dark:text-gray-500">—</span>;
  }

  const sourceLabel = info.source === 'runtime' ? 'rilevato' : 'atteso';
  const sourceTitle =
    info.source === 'runtime'
      ? 'IP rilevato in tempo reale tramite VMware Tools'
      : 'IP atteso dal catalogo; disponibile anche a VM spenta';

  return (
    <span className="inline-flex flex-wrap items-center gap-1.5" title={sourceTitle}>
      {showIcon && (
        <FaNetworkWired
          size={12}
          className="text-gray-400 dark:text-gray-500"
          aria-hidden="true"
        />
      )}
      <span className="font-medium tabular-nums text-gray-800 dark:text-gray-100">
        {info.primary}
      </span>
      <span
        className={`rounded-full px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${
          info.source === 'runtime'
            ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300'
            : 'bg-sky-100 text-sky-700 dark:bg-sky-900/50 dark:text-sky-300'
        }`}
      >
        {sourceLabel}
      </span>
      {info.mismatch && (
        <span
          className="inline-flex items-center gap-1 text-[10px] font-semibold text-amber-700 dark:text-amber-300"
          title={`IP non presente nel catalogo (${info.expectedIps.join(', ')})`}
        >
          <FaExclamationTriangle size={10} aria-hidden="true" />
          {!compact && 'diverso dal catalogo'}
        </span>
      )}
    </span>
  );
}
